export const REPORT_TEMPLATE_4x3_LAYOUT = `{
        "header": {
          "id": "ced54cf6-edc0-44b0-bd87-fa74d58d007c",
          "texts": [
            {
              "text": "Sample header 1",
              "type": "dynamic-editable",
              "dynamicId": null,
              "inputType": "text",
              "editableId": "page2_header1",
              "format": null,
              "label": "Header 1 (This text will repeat on every page)",
              "validation": {
                "required": false,
                "maxLength": 100
              },
              "options": [],
              "multiSelectDelimiter": "comma",
              "radioType": null,
              "value": null,
              "radioLabel": null,
              "inputGroup": "Page 2",
              "isTableText": false,
              "fontSize": 3.0,
              "fontFamily": "Arial",
              "fontColor": null,
              "fontStyle": null,
              "fontWeight": null,
              "lineHeight": null,
              "horizontalAlign": "left",
              "verticalAlign": "middle",
              "isHorizontal": true,
              "borderStyle": null,
              "borderWidth": null,
              "borderColor": null,
              "backgroundColor": "transparent",
              "paddingTop": 0.5,
              "paddingBottom": 0.5,
              "paddingRight": 0.5,
              "paddingLeft": 0.5,
              "id": "eb562543-0caa-43de-ba21-cb9bbf16387c",
              "x": 7.0,
              "y": 4.0,
              "width": 100.0,
              "height": 8.0,
              "zIndex": null
            },
            {
              "text": "Sample header 2",
              "type": "dynamic-editable",
              "dynamicId": null,
              "inputType": "text",
              "editableId": "page2_header2",
              "format": null,
              "label": "Header 2 (This text will repeat on every page)",
              "validation": {
                "required": false,
                "maxLength": 100
              },
              "options": [],
              "multiSelectDelimiter": "comma",
              "radioType": null,
              "value": null,
              "radioLabel": null,
              "inputGroup": "Page 2",
              "isTableText": false,
              "fontSize": 3.0,
              "fontFamily": "Arial",
              "fontColor": null,
              "fontStyle": null,
              "fontWeight": null,
              "lineHeight": null,
              "horizontalAlign": "right",
              "verticalAlign": "middle",
              "isHorizontal": true,
              "borderStyle": null,
              "borderWidth": null,
              "borderColor": null,
              "backgroundColor": "transparent",
              "paddingTop": 0.5,
              "paddingBottom": 0.5,
              "paddingRight": 0.5,
              "paddingLeft": 0.5,
              "id": "c8d3bdb4-4852-4935-b173-c34a0b0a0851",
              "x": 108.0,
              "y": 4.0,
              "width": 100.0,
              "height": 8.0,
              "zIndex": null
            }
          ],
          "images": [],
          "lines": [],
          "rectangles": [],
          "height": 15.0
        },
        "bodies": [
          {
            "hasHeader": false,
            "hasFooter": false,
            "inspectionSummary": null,
            "subTotal": null,
            "inspectionPictures": null,
            "dataPlates": null,
            "id": "13d069f5-8fbb-409c-9058-6e76d56601b6",
            "texts": [
              {
                "text": "Borescope Inspection Report",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "textArea",
                "editableId": "page1_title",
                "format": null,
                "label": "Report Title",
                "validation": {
                  "required": false,
                  "maxLength": 1000
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 1",
                "isTableText": false,
                "fontSize": 8.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": "bold",
                "lineHeight": null,
                "horizontalAlign": "center",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "fe993e62-9655-47f9-ae43-3eca601a1f0e",
                "x": 1.0,
                "y": 29.0,
                "width": 214.0,
                "height": 55.0,
                "zIndex": null
              },
              {
                "text": "Inspection Date:",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page1_label_date",
                "format": null,
                "label": "Date Label",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 1",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "b5d3766c-8c3b-4789-bdfa-47e39174bf55",
                "x": 30.0,
                "y": 226.0,
                "width": 60.0,
                "height": 7.9,
                "zIndex": null
              },
              {
                "text": "Sample Date",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page1_date",
                "format": null,
                "label": "Inspection Date",
                "validation": {
                  "required": false,
                  "maxLength": 200
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 1",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "64f2381a-e884-4015-8385-21b0b810a42b",
                "x": 95.0,
                "y": 226.0,
                "width": 110.0,
                "height": 7.9,
                "zIndex": null
              },
              {
                "text": "Inspector:",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page1_label_inspector",
                "format": null,
                "label": "Inspector Label",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 1",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "ddff16ef-2138-4382-9d42-6deee6e4dc34",
                "x": 30.0,
                "y": 238.0,
                "width": 60.0,
                "height": 7.9,
                "zIndex": null
              },
              {
                "text": "Sample inspector name",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page_1_inspector",
                "format": null,
                "label": "Inspector Name",
                "validation": {
                  "required": false,
                  "maxLength": 200
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 1",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "a5b916e0-0639-465f-b7f3-22d1038c1987",
                "x": 95.0,
                "y": 238.0,
                "width": 110.0,
                "height": 7.9,
                "zIndex": null
              },
              {
                "text": "Asset Inspected:",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page1_label_asset",
                "format": null,
                "label": "Asset Label",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 1",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "afeca79f-a06b-41c3-bac6-4f48302ef197",
                "x": 30.0,
                "y": 250.0,
                "width": 60.0,
                "height": 7.9,
                "zIndex": null
              },
              {
                "text": "Sample Asset name",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page1_asset",
                "format": null,
                "label": "Asset Inspected",
                "validation": {
                  "required": false,
                  "maxLength": 200
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 1",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "c1ee677d-9a0e-46c4-a731-c9eff8b348b4",
                "x": 95.0,
                "y": 250.0,
                "width": 110.0,
                "height": 7.9,
                "zIndex": null
              },
              {
                "text": "Location:",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page1_label_location",
                "format": null,
                "label": "Location Label",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 1",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "59827d0e-1d99-4c31-a07c-1581757cbbda",
                "x": 30.0,
                "y": 262.0,
                "width": 60.0,
                "height": 7.9,
                "zIndex": null
              },
              {
                "text": "Sample location name",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page1_location",
                "format": null,
                "label": "Location",
                "validation": {
                  "required": false,
                  "maxLength": 200
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 1",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "317f6387-d4da-4a47-b49d-b9b9285d47b5",
                "x": 95.0,
                "y": 262.0,
                "width": 110.0,
                "height": 7.9,
                "zIndex": null
              }
            ],
            "images": [],
            "lines": [],
            "rectangles": [],
            "height": 0.0
          },
          {
            "hasHeader": true,
            "hasFooter": true,
            "inspectionSummary": null,
            "subTotal": null,
            "inspectionPictures": null,
            "dataPlates": null,
            "id": "72c74454-fb13-4842-aef8-04b7585a7755",
            "texts": [
              {
                "text": "Section 1",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_section1",
                "format": null,
                "label": "Page 2 Section 1",
                "validation": {
                  "required": false,
                  "maxLength": 1000
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": "#ffffff",
                "fontStyle": null,
                "fontWeight": "bolder",
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "#08107b",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "e16fabf2-f733-4581-9557-e889feb4d351",
                "x": 8.0,
                "y": 4.0,
                "width": 200.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample label",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_label1",
                "format": null,
                "label": "Section 1 Label 1",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "5a398a09-2872-4a93-bec3-2c4901ef5875",
                "x": 8.0,
                "y": 20.0,
                "width": 70.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample text",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_text1",
                "format": null,
                "label": "Section 1 Text 1",
                "validation": {
                  "required": false,
                  "maxLength": 200
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "9b788fc1-37f6-4a74-94c3-964fe298579c",
                "x": 80.0,
                "y": 20.0,
                "width": 128.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample label",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_label2",
                "format": null,
                "label": "Section 1 Label 2",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "2d96493c-8809-44b4-80ab-c8ee1bccbf5c",
                "x": 8.0,
                "y": 30.0,
                "width": 70.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample text",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_text2",
                "format": null,
                "label": "Section 1 Text 2",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "0a00313e-0d76-45e6-b01f-8c693c51649e",
                "x": 80.0,
                "y": 30.0,
                "width": 128.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample label",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_label3",
                "format": null,
                "label": "Section 1 Label 3",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "e4a4a210-572f-463c-b0ea-035f91c7a1d9",
                "x": 8.0,
                "y": 40.0,
                "width": 70.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample text",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_text3",
                "format": null,
                "label": "Section 1 Text 3",
                "validation": {
                  "required": false,
                  "maxLength": 200
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "076882cd-84fe-4060-b755-2fd3462c13c7",
                "x": 80.0,
                "y": 40.0,
                "width": 128.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample label",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_label4",
                "format": null,
                "label": "Section 1 Label 4",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "f767884c-154b-4522-a3e0-3fd670c68f14",
                "x": 8.0,
                "y": 50.0,
                "width": 70.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample text",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_text4",
                "format": null,
                "label": "Section 1 Text 4",
                "validation": {
                  "required": false,
                  "maxLength": 200
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "89ef50b9-a496-494e-920f-f155db752ae7",
                "x": 80.0,
                "y": 50.0,
                "width": 128.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample label",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_label5",
                "format": null,
                "label": "Section 1 Label 5",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "e8cf755e-f3d1-4c4a-b335-4f8bd2dfa5aa",
                "x": 8.0,
                "y": 60.0,
                "width": 70.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample text",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_text5",
                "format": null,
                "label": "Section 1 Text 5",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "bec4f9c9-c83f-41c0-997b-a795c6885ce1",
                "x": 80.0,
                "y": 60.0,
                "width": 128.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample label",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_label6",
                "format": null,
                "label": "Section 1 Label 6",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "fdc5c3a6-fa45-4394-b284-d5b2ca8fe394",
                "x": 8.0,
                "y": 70.0,
                "width": 70.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample text",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_text6",
                "format": null,
                "label": "Section 1 Text 6",
                "validation": {
                  "required": false,
                  "maxLength": 200
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "d63a1290-bbc5-40f0-ba4e-03a4d555d3c9",
                "x": 80.0,
                "y": 70.0,
                "width": 128.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample label",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_label7",
                "format": null,
                "label": "Section 1 Label 7",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "566be9ad-eb98-495d-9dfb-4575d3874977",
                "x": 8.0,
                "y": 80.0,
                "width": 70.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample text",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_text7",
                "format": null,
                "label": "Section 1 Text 7",
                "validation": {
                  "required": false,
                  "maxLength": 200
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "b334e29d-75db-4795-915c-3e23c1d1eabd",
                "x": 80.0,
                "y": 80.0,
                "width": 128.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample label",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_label8",
                "format": null,
                "label": "Section 1 Label 8",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "d73bf6a5-ce77-44ad-85e7-e2c234321d99",
                "x": 8.0,
                "y": 90.0,
                "width": 70.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample text",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_s1_text8",
                "format": null,
                "label": "Section 1 Text 8",
                "validation": {
                  "required": false,
                  "maxLength": 200
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "8f824685-9baa-44fe-8bc5-8148314f8bbb",
                "x": 80.0,
                "y": 90.0,
                "width": 128.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Section 2",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_section2",
                "format": null,
                "label": "Page 2 Section 2",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": "#03050e",
                "fontStyle": null,
                "fontWeight": "bolder",
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "#ffffff",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "da464c6a-a519-45c1-81a9-7d526d0f693a",
                "x": 8.0,
                "y": 110.0,
                "width": 200.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample text",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "textArea",
                "editableId": "page2_s2_text1",
                "format": null,
                "label": "Section 2 Text 1",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "top",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "26ca9501-ac1c-4436-96b6-fca72a606ac3",
                "x": 8.0,
                "y": 125.0,
                "width": 200.0,
                "height": 50.0,
                "zIndex": null
              },
              {
                "text": "Section 3",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page2_section3",
                "format": null,
                "label": "Page 2 Section 3",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": "",
                "fontStyle": null,
                "fontWeight": "bolder",
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "760f51d4-6330-4c6d-9be2-265d5048d38d",
                "x": 8.0,
                "y": 180.0,
                "width": 200.0,
                "height": 8.0,
                "zIndex": null
              },
              {
                "text": "Sample text",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "textArea",
                "editableId": "page2_s3_text1",
                "format": null,
                "label": "Section 3 Text 1",
                "validation": {
                  "required": false,
                  "maxLength": 1000
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 2",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "top",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "transparent",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "29d881cc-9110-4318-a118-9b15fb31e079",
                "x": 8.0,
                "y": 195.0,
                "width": 200.0,
                "height": 50.0,
                "zIndex": null
              }
            ],
            "images": [],
            "lines": [],
            "rectangles": [],
            "height": 0.0
          },
          {
            "hasHeader": true,
            "hasFooter": true,
            "inspectionSummary": null,
            "subTotal": null,
            "inspectionPictures": null,
            "dataPlates": {
              "title": {
                "text": null,
                "type": "static",
                "dynamicId": null,
                "inputType": "text",
                "editableId": null,
                "format": null,
                "label": null,
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": null,
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "center",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": null,
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "b3f2d09a-0f79-4f4c-87f0-32823da376f9",
                "x": 8.0,
                "y": 23.8,
                "width": 200.0,
                "height": 1.0,
                "zIndex": 0
              },
              "imageInfo": {
                "title": {
                  "position": "top",
                  "fontSize": 5.0,
                  "fontFamily": "Arial",
                  "fontColor": null,
                  "fontStyle": null,
                  "fontWeight": null,
                  "lineHeight": null,
                  "horizontalAlign": "center",
                  "verticalAlign": "middle",
                  "isHorizontal": true,
                  "borderStyle": null,
                  "borderWidth": null,
                  "borderColor": null,
                  "backgroundColor": null,
                  "paddingTop": 0.5,
                  "paddingBottom": 0.5,
                  "paddingRight": 0.5,
                  "paddingLeft": 0.5,
                  "id": "ade345e3-8e86-412d-a7a2-470d59f09c0a",
                  "x": 0.0,
                  "y": 20.0,
                  "width": 200.0,
                  "height": 30.0,
                  "zIndex": 0
                },
                "image": {
                  "Caption": null,
                  "src": null,
                  "type": "static",
                  "IsAbsolute": true,
                  "Orientation": 0,
                  "IsDummy": false,
                  "IsEdit": false,
                  "id": "045e30ec-ce97-4ab5-94e0-3c72c46b95c0",
                  "x": 0.0,
                  "y": 11.7,
                  "width": 90.0,
                  "height": 0.0,
                  "zIndex": 0
                },
                "id": "cd5dc3b2-7903-44f3-b215-80ccf7ee1546",
                "x": 8.0,
                "y": 14.0,
                "width": 200.0,
                "height": 220.0,
                "zIndex": 1
              },
              "id": "1d5bc66d-40e3-4d78-a1d4-de7e5ac86d12",
              "x": 0.0,
              "y": 0.0,
              "width": 0.0,
              "height": 0.0,
              "zIndex": 0
            },
            "id": "5c10e395-d5b6-4d4f-ae40-8bb84b427d43",
            "texts": [
              {
                "text": "Data Plate",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page3_section1",
                "format": null,
                "label": "Page 3 Section 1",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 3",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": "#ffffff",
                "fontStyle": null,
                "fontWeight": "bolder",
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "#08107b",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "e9af5b06-9ee6-4ce2-b9e0-4811ede649e4",
                "x": 8.0,
                "y": 4.0,
                "width": 200.0,
                "height": 8.0,
                "zIndex": null
              }
            ],
            "images": [],
            "lines": [],
            "rectangles": [],
            "height": 0.0
          },
          {
            "hasHeader": true,
            "hasFooter": true,
            "inspectionSummary": {
              "defaultPageBreakRowCount": 6,
              "isEmptyFolderDisplayed": true,
              "title": {
                "text": null,
                "type": "static",
                "dynamicId": null,
                "inputType": "text",
                "editableId": null,
                "format": null,
                "label": null,
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": null,
                "isTableText": false,
                "fontSize": 16.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "1797655f-008a-4cb5-b075-0f989096ca46",
                "x": 8.0,
                "y": 2.0,
                "width": 200.0,
                "height": 1.0,
                "zIndex": 0
              },
              "table": {
                "columns": [
                  {
                    "header": "Location",
                    "headerType": null,
                    "texts": [],
                    "textsInfo": [
                      {
                        "text": null,
                        "type": "dynamic",
                        "dynamicId": "inspectionSummary.location[0].identifier",
                        "inputType": "text",
                        "editableId": null,
                        "format": null,
                        "label": null,
                        "validation": {
                          "required": false,
                          "maxLength": 100
                        },
                        "options": null,
                        "multiSelectDelimiter": "comma",
                        "radioType": null,
                        "value": null,
                        "radioLabel": null,
                        "inputGroup": null,
                        "isTableText": true,
                        "fontSize": null,
                        "fontFamily": null,
                        "fontColor": null,
                        "fontStyle": null,
                        "fontWeight": null,
                        "lineHeight": null,
                        "horizontalAlign": null,
                        "verticalAlign": null,
                        "isHorizontal": true,
                        "borderStyle": null,
                        "borderWidth": null,
                        "borderColor": null,
                        "backgroundColor": null,
                        "paddingTop": null,
                        "paddingBottom": null,
                        "paddingRight": null,
                        "paddingLeft": null,
                        "id": "a75106c503bb4555815ea87b16925c85",
                        "x": 0.0,
                        "y": 0.0,
                        "width": 0.0,
                        "height": 0.0,
                        "zIndex": null
                      }
                    ],
                    "fontSize": 4.0,
                    "fontFamily": null,
                    "horizontalAlign": "center",
                    "verticalAlign": null,
                    "paddingTop": null,
                    "paddingBottom": null,
                    "paddingRight": null,
                    "paddingLeft": null,
                    "widthRatio": 15.0,
                    "isHeaderVertical": false,
                    "isColumnVertical": false,
                    "isCombined": false,
                    "isItemsHorizontal": false
                  },
                  {
                    "header": "Sub Location",
                    "headerType": null,
                    "texts": [],
                    "textsInfo": [
                      {
                        "text": null,
                        "type": "dynamic",
                        "dynamicId": "inspectionSummary.location.name",
                        "inputType": "text",
                        "editableId": null,
                        "format": null,
                        "label": null,
                        "validation": {
                          "required": false,
                          "maxLength": 100
                        },
                        "options": null,
                        "multiSelectDelimiter": "comma",
                        "radioType": null,
                        "value": null,
                        "radioLabel": null,
                        "inputGroup": null,
                        "isTableText": true,
                        "fontSize": null,
                        "fontFamily": null,
                        "fontColor": null,
                        "fontStyle": null,
                        "fontWeight": null,
                        "lineHeight": null,
                        "horizontalAlign": null,
                        "verticalAlign": null,
                        "isHorizontal": true,
                        "borderStyle": null,
                        "borderWidth": null,
                        "borderColor": null,
                        "backgroundColor": null,
                        "paddingTop": null,
                        "paddingBottom": null,
                        "paddingRight": null,
                        "paddingLeft": null,
                        "id": "b4e7c11988b343b3980576bd1becfe5d",
                        "x": 0.0,
                        "y": 0.0,
                        "width": 0.0,
                        "height": 0.0,
                        "zIndex": null
                      }
                    ],
                    "fontSize": 4.0,
                    "fontFamily": null,
                    "horizontalAlign": "center",
                    "verticalAlign": null,
                    "paddingTop": null,
                    "paddingBottom": null,
                    "paddingRight": null,
                    "paddingLeft": null,
                    "widthRatio": 15.0,
                    "isHeaderVertical": false,
                    "isColumnVertical": false,
                    "isCombined": false,
                    "isItemsHorizontal": false
                  },
                  {
                    "header": "Results/Comments",
                    "headerType": null,
                    "texts": [],
                    "textsInfo": [
                      {
                        "text": null,
                        "type": "dynamic",
                        "dynamicId": "inspection.identifier.comment",
                        "inputType": "text",
                        "editableId": null,
                        "format": null,
                        "label": null,
                        "validation": {
                          "required": false,
                          "maxLength": 100
                        },
                        "options": null,
                        "multiSelectDelimiter": "comma",
                        "radioType": null,
                        "value": null,
                        "radioLabel": null,
                        "inputGroup": null,
                        "isTableText": true,
                        "fontSize": null,
                        "fontFamily": null,
                        "fontColor": null,
                        "fontStyle": null,
                        "fontWeight": null,
                        "lineHeight": null,
                        "horizontalAlign": null,
                        "verticalAlign": null,
                        "isHorizontal": true,
                        "borderStyle": null,
                        "borderWidth": null,
                        "borderColor": null,
                        "backgroundColor": null,
                        "paddingTop": null,
                        "paddingBottom": null,
                        "paddingRight": null,
                        "paddingLeft": null,
                        "id": "5abd1d627d934946b67650bbd43c2258",
                        "x": 0.0,
                        "y": 0.0,
                        "width": 0.0,
                        "height": 0.0,
                        "zIndex": null
                      }
                    ],
                    "fontSize": 4.0,
                    "fontFamily": null,
                    "horizontalAlign": "center",
                    "verticalAlign": "middle",
                    "paddingTop": null,
                    "paddingBottom": null,
                    "paddingRight": null,
                    "paddingLeft": null,
                    "widthRatio": 35.0,
                    "isHeaderVertical": false,
                    "isColumnVertical": false,
                    "isCombined": false,
                    "isItemsHorizontal": false
                  }
                ],
                "headerHeight": 10.0,
                "headerFontSize": 4.0,
                "headerFontFamily": "Arial",
                "horizontalAlign": "left",
                "headerBackgroundColor": null,
                "borderStyle": "solid",
                "borderWidth": "0.2",
                "borderColor": "#d3d3d3",
                "hasBorderTop": true,
                "hasBorderBottom": true,
                "hasBorderLeft": true,
                "hasBorderRight": true,
                "hasRowBackground": true,
                "rowBackgroundColor": null,
                "tableMode": false,
                "dataMode": 0,
                "id": "c0f35e03-5b19-4f1f-b247-a2580aa47a8c",
                "x": 8.0,
                "y": 13.0,
                "width": 200.0,
                "height": 0.0,
                "zIndex": 0
              },
              "id": "f344d437-1129-4ec4-a2f2-8f43257e36b6",
              "x": 0.0,
              "y": 0.0,
              "width": 0.0,
              "height": 0.0,
              "zIndex": 0
            },
            "subTotal": null,
            "inspectionPictures": null,
            "dataPlates": null,
            "id": "587c3ed4-522c-4935-9c95-5a573aa34156",
            "texts": [
              {
                "text": "Inspection Summary",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page4_section1",
                "format": null,
                "label": "Page 4 Section 1",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 4",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": "#ffffff",
                "fontStyle": null,
                "fontWeight": "bolder",
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "#08107b",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "412e671f-0613-47b8-b15e-219bcb92689a",
                "x": 8.0,
                "y": 4.0,
                "width": 200.0,
                "height": 8.0,
                "zIndex": null
              }
            ],
            "images": [],
            "lines": [],
            "rectangles": [],
            "height": 0.0
          },
          {
            "hasHeader": true,
            "hasFooter": true,
            "inspectionSummary": null,
            "subTotal": null,
            "inspectionPictures": {
              "defaultPageBreakRowCount": 3,
              "hasInspectionSummaryLink": true,
              "title": {
                "text": null,
                "type": "static",
                "dynamicId": null,
                "inputType": "text",
                "editableId": null,
                "format": null,
                "label": null,
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": null,
                "isTableText": false,
                "fontSize": 4.0,
                "fontFamily": "Arial",
                "fontColor": null,
                "fontStyle": null,
                "fontWeight": null,
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "#ffffff",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "5433b313-9aca-44d0-87af-8cb1639dc70a",
                "x": 8.0,
                "y": 6.0,
                "width": 200.0,
                "height": 1.0,
                "zIndex": 0
              },
              "table": {
                "columns": [
                  {
                    "header": "Location",
                    "headerType": null,
                    "texts": [],
                    "textsInfo": [
                      {
                        "text": null,
                        "type": "dynamic",
                        "dynamicId": "inspectionPictures.location[0].identifier",
                        "inputType": "text",
                        "editableId": null,
                        "format": null,
                        "label": null,
                        "validation": {
                          "required": false,
                          "maxLength": 100
                        },
                        "options": null,
                        "multiSelectDelimiter": "comma",
                        "radioType": null,
                        "value": null,
                        "radioLabel": null,
                        "inputGroup": null,
                        "isTableText": true,
                        "fontSize": null,
                        "fontFamily": null,
                        "fontColor": null,
                        "fontStyle": null,
                        "fontWeight": null,
                        "lineHeight": null,
                        "horizontalAlign": null,
                        "verticalAlign": null,
                        "isHorizontal": true,
                        "borderStyle": null,
                        "borderWidth": null,
                        "borderColor": null,
                        "backgroundColor": null,
                        "paddingTop": null,
                        "paddingBottom": null,
                        "paddingRight": null,
                        "paddingLeft": null,
                        "id": "34ea52495955432e87e96b602d5c038b",
                        "x": 0.0,
                        "y": 0.0,
                        "width": 0.0,
                        "height": 0.0,
                        "zIndex": null
                      },
                      {
                        "text": null,
                        "type": "dynamic",
                        "dynamicId": "inspectionPictures.location.name",
                        "inputType": "text",
                        "editableId": null,
                        "format": null,
                        "label": null,
                        "validation": {
                          "required": false,
                          "maxLength": 100
                        },
                        "options": null,
                        "multiSelectDelimiter": "comma",
                        "radioType": null,
                        "value": null,
                        "radioLabel": null,
                        "inputGroup": null,
                        "isTableText": true,
                        "fontSize": null,
                        "fontFamily": null,
                        "fontColor": null,
                        "fontStyle": null,
                        "fontWeight": null,
                        "lineHeight": null,
                        "horizontalAlign": null,
                        "verticalAlign": null,
                        "isHorizontal": true,
                        "borderStyle": null,
                        "borderWidth": null,
                        "borderColor": null,
                        "backgroundColor": null,
                        "paddingTop": null,
                        "paddingBottom": null,
                        "paddingRight": null,
                        "paddingLeft": null,
                        "id": "484d950ad014470f8a78becb8db3ad3c",
                        "x": 0.0,
                        "y": 0.0,
                        "width": 0.0,
                        "height": 0.0,
                        "zIndex": null
                      }
                    ],
                    "fontSize": 4.0,
                    "fontFamily": null,
                    "horizontalAlign": "center",
                    "verticalAlign": "middle",
                    "paddingTop": null,
                    "paddingBottom": null,
                    "paddingRight": null,
                    "paddingLeft": null,
                    "widthRatio": 15.0,
                    "isHeaderVertical": false,
                    "isColumnVertical": false,
                    "isCombined": false,
                    "isItemsHorizontal": false
                  },
                  {
                    "header": "",
                    "headerType": null,
                    "texts": [],
                    "textsInfo": [
                      {
                        "text": null,
                        "type": "dynamic",
                        "dynamicId": "inspectionPictures.image",
                        "inputType": "text",
                        "editableId": null,
                        "format": null,
                        "label": null,
                        "validation": {
                          "required": false,
                          "maxLength": 100
                        },
                        "options": null,
                        "multiSelectDelimiter": "comma",
                        "radioType": null,
                        "value": null,
                        "radioLabel": null,
                        "inputGroup": null,
                        "isTableText": true,
                        "fontSize": null,
                        "fontFamily": null,
                        "fontColor": null,
                        "fontStyle": null,
                        "fontWeight": null,
                        "lineHeight": null,
                        "horizontalAlign": null,
                        "verticalAlign": null,
                        "isHorizontal": true,
                        "borderStyle": null,
                        "borderWidth": null,
                        "borderColor": null,
                        "backgroundColor": null,
                        "paddingTop": null,
                        "paddingBottom": null,
                        "paddingRight": null,
                        "paddingLeft": null,
                        "id": "02096e2cd101469e921bcb9443787e0a",
                        "x": 0.0,
                        "y": 0.0,
                        "width": 0.0,
                        "height": 0.0,
                        "zIndex": null
                      }
                    ],
                    "fontSize": null,
                    "fontFamily": null,
                    "horizontalAlign": "center",
                    "verticalAlign": "middle",
                    "paddingTop": null,
                    "paddingBottom": null,
                    "paddingRight": null,
                    "paddingLeft": null,
                    "widthRatio": 50.0,
                    "isHeaderVertical": false,
                    "isColumnVertical": false,
                    "isCombined": false,
                    "isItemsHorizontal": false
                  },
                  {
                    "header": "",
                    "headerType": null,
                    "texts": [],
                    "textsInfo": [
                      {
                        "text": null,
                        "type": "dynamic",
                        "dynamicId": "inspectionPictures.class",
                        "inputType": "text",
                        "editableId": null,
                        "format": null,
                        "label": null,
                        "validation": {
                          "required": false,
                          "maxLength": 100
                        },
                        "options": null,
                        "multiSelectDelimiter": "comma",
                        "radioType": null,
                        "value": null,
                        "radioLabel": null,
                        "inputGroup": null,
                        "isTableText": true,
                        "fontSize": null,
                        "fontFamily": null,
                        "fontColor": null,
                        "fontStyle": null,
                        "fontWeight": null,
                        "lineHeight": null,
                        "horizontalAlign": null,
                        "verticalAlign": null,
                        "isHorizontal": true,
                        "borderStyle": null,
                        "borderWidth": null,
                        "borderColor": null,
                        "backgroundColor": null,
                        "paddingTop": null,
                        "paddingBottom": null,
                        "paddingRight": null,
                        "paddingLeft": null,
                        "id": "aa84a17471f240b79195b0fae44b0d50",
                        "x": 0.0,
                        "y": 0.0,
                        "width": 0.0,
                        "height": 0.0,
                        "zIndex": null
                      }
                    ],
                    "fontSize": 4.0,
                    "fontFamily": null,
                    "horizontalAlign": "center",
                    "verticalAlign": "middle",
                    "paddingTop": null,
                    "paddingBottom": null,
                    "paddingRight": null,
                    "paddingLeft": null,
                    "widthRatio": 5.0,
                    "isHeaderVertical": false,
                    "isColumnVertical": false,
                    "isCombined": false,
                    "isItemsHorizontal": false
                  },
                  {
                    "header": "Results/Comments",
                    "headerType": null,
                    "texts": [],
                    "textsInfo": [
                      {
                        "text": null,
                        "type": "dynamic",
                        "dynamicId": "inspectionPictures.mark",
                        "inputType": "text",
                        "editableId": null,
                        "format": null,
                        "label": null,
                        "validation": {
                          "required": false,
                          "maxLength": 100
                        },
                        "options": null,
                        "multiSelectDelimiter": "comma",
                        "radioType": null,
                        "value": null,
                        "radioLabel": null,
                        "inputGroup": null,
                        "isTableText": true,
                        "fontSize": null,
                        "fontFamily": null,
                        "fontColor": null,
                        "fontStyle": null,
                        "fontWeight": null,
                        "lineHeight": null,
                        "horizontalAlign": null,
                        "verticalAlign": null,
                        "isHorizontal": true,
                        "borderStyle": null,
                        "borderWidth": null,
                        "borderColor": null,
                        "backgroundColor": null,
                        "paddingTop": null,
                        "paddingBottom": null,
                        "paddingRight": null,
                        "paddingLeft": null,
                        "id": "f56cc4c562624143ac9ececda512bca3",
                        "x": 0.0,
                        "y": 0.0,
                        "width": 0.0,
                        "height": 0.0,
                        "zIndex": null
                      },
                      {
                        "text": null,
                        "type": "dynamic",
                        "dynamicId": "inspectionPictures.title",
                        "inputType": "text",
                        "editableId": null,
                        "format": null,
                        "label": null,
                        "validation": {
                          "required": false,
                          "maxLength": 100
                        },
                        "options": null,
                        "multiSelectDelimiter": "comma",
                        "radioType": null,
                        "value": null,
                        "radioLabel": null,
                        "inputGroup": null,
                        "isTableText": true,
                        "fontSize": null,
                        "fontFamily": null,
                        "fontColor": null,
                        "fontStyle": null,
                        "fontWeight": null,
                        "lineHeight": null,
                        "horizontalAlign": null,
                        "verticalAlign": null,
                        "isHorizontal": true,
                        "borderStyle": null,
                        "borderWidth": null,
                        "borderColor": null,
                        "backgroundColor": null,
                        "paddingTop": null,
                        "paddingBottom": null,
                        "paddingRight": null,
                        "paddingLeft": null,
                        "id": "408ea275f5fd48119b612d6ac664dab3",
                        "x": 0.0,
                        "y": 0.0,
                        "width": 0.0,
                        "height": 0.0,
                        "zIndex": null
                      },
                      {
                        "text": null,
                        "type": "dynamic",
                        "dynamicId": "inspectionPictures.comment",
                        "inputType": "text",
                        "editableId": null,
                        "format": null,
                        "label": null,
                        "validation": {
                          "required": false,
                          "maxLength": 100
                        },
                        "options": null,
                        "multiSelectDelimiter": "comma",
                        "radioType": null,
                        "value": null,
                        "radioLabel": null,
                        "inputGroup": null,
                        "isTableText": true,
                        "fontSize": null,
                        "fontFamily": null,
                        "fontColor": null,
                        "fontStyle": null,
                        "fontWeight": null,
                        "lineHeight": null,
                        "horizontalAlign": null,
                        "verticalAlign": null,
                        "isHorizontal": true,
                        "borderStyle": null,
                        "borderWidth": null,
                        "borderColor": null,
                        "backgroundColor": null,
                        "paddingTop": null,
                        "paddingBottom": null,
                        "paddingRight": null,
                        "paddingLeft": null,
                        "id": "2fbab1f467414955a27de5cd75113405",
                        "x": 0.0,
                        "y": 0.0,
                        "width": 0.0,
                        "height": 0.0,
                        "zIndex": null
                      },
                      {
                        "text": null,
                        "type": "dynamic",
                        "dynamicId": "measurementResult",
                        "inputType": "text",
                        "editableId": null,
                        "format": null,
                        "label": null,
                        "validation": {
                          "required": false,
                          "maxLength": 100
                        },
                        "options": null,
                        "multiSelectDelimiter": "comma",
                        "radioType": null,
                        "value": null,
                        "radioLabel": null,
                        "inputGroup": null,
                        "isTableText": true,
                        "fontSize": null,
                        "fontFamily": null,
                        "fontColor": null,
                        "fontStyle": null,
                        "fontWeight": null,
                        "lineHeight": null,
                        "horizontalAlign": null,
                        "verticalAlign": null,
                        "isHorizontal": true,
                        "borderStyle": null,
                        "borderWidth": null,
                        "borderColor": null,
                        "backgroundColor": null,
                        "paddingTop": null,
                        "paddingBottom": null,
                        "paddingRight": null,
                        "paddingLeft": null,
                        "id": "1ce89a52f6bd4429bdeb4f144607e7b6",
                        "x": 0.0,
                        "y": 0.0,
                        "width": 0.0,
                        "height": 0.0,
                        "zIndex": null
                      }
                    ],
                    "fontSize": 4.0,
                    "fontFamily": null,
                    "horizontalAlign": "left",
                    "verticalAlign": null,
                    "paddingTop": null,
                    "paddingBottom": null,
                    "paddingRight": null,
                    "paddingLeft": null,
                    "widthRatio": 25.0,
                    "isHeaderVertical": false,
                    "isColumnVertical": false,
                    "isCombined": false,
                    "isItemsHorizontal": false
                  }
                ],
                "headerHeight": 10.0,
                "headerFontSize": 4.0,
                "headerFontFamily": "Arial",
                "horizontalAlign": "left",
                "headerBackgroundColor": null,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "hasBorderTop": true,
                "hasBorderBottom": true,
                "hasBorderLeft": true,
                "hasBorderRight": true,
                "hasRowBackground": false,
                "rowBackgroundColor": null,
                "tableMode": false,
                "dataMode": 1,
                "id": "31168851-8bab-4f2b-968e-db73caf1f607",
                "x": 8.0,
                "y": 15.0,
                "width": 200.0,
                "height": 230.0,
                "zIndex": 0
              },
              "id": "eac758e0-79ae-4b7c-baa9-c4a94ea083b8",
              "x": 0.0,
              "y": 0.0,
              "width": 0.0,
              "height": 0.0,
              "zIndex": 0
            },
            "dataPlates": null,
            "id": "4c8679f7-14c3-42cc-8df2-659a33b2971a",
            "texts": [
              {
                "text": "Inspection Images",
                "type": "dynamic-editable",
                "dynamicId": null,
                "inputType": "text",
                "editableId": "page5_section1",
                "format": null,
                "label": "Page 5 Section 1",
                "validation": {
                  "required": false,
                  "maxLength": 100
                },
                "options": [],
                "multiSelectDelimiter": "comma",
                "radioType": null,
                "value": null,
                "radioLabel": null,
                "inputGroup": "Page 5",
                "isTableText": false,
                "fontSize": 5.0,
                "fontFamily": "Arial",
                "fontColor": "#ffffff",
                "fontStyle": null,
                "fontWeight": "bolder",
                "lineHeight": null,
                "horizontalAlign": "left",
                "verticalAlign": "middle",
                "isHorizontal": true,
                "borderStyle": null,
                "borderWidth": null,
                "borderColor": null,
                "backgroundColor": "#08107b",
                "paddingTop": 0.5,
                "paddingBottom": 0.5,
                "paddingRight": 0.5,
                "paddingLeft": 0.5,
                "id": "b7a17d6e-3b36-4dcf-bdb6-b8d9ef1d2755",
                "x": 8.0,
                "y": 6.0,
                "width": 200.0,
                "height": 8.0,
                "zIndex": null
              }
            ],
            "images": [],
            "lines": [],
            "rectangles": [],
            "height": 0.0
          }
        ],
        "footer": {
          "id": "",
          "texts": [
            {
              "text": null,
              "type": "dynamic",
              "dynamicId": "pageNumber",
              "inputType": "text",
              "editableId": null,
              "format": "Page $ of #",
              "label": null,
              "validation": {
                "required": false,
                "maxLength": 100
              },
              "options": [],
              "multiSelectDelimiter": "comma",
              "radioType": null,
              "value": null,
              "radioLabel": null,
              "inputGroup": null,
              "isTableText": false,
              "fontSize": 3.0,
              "fontFamily": "Arial",
              "fontColor": null,
              "fontStyle": null,
              "fontWeight": null,
              "lineHeight": null,
              "horizontalAlign": "left",
              "verticalAlign": "middle",
              "isHorizontal": true,
              "borderStyle": null,
              "borderWidth": null,
              "borderColor": null,
              "backgroundColor": "transparent",
              "paddingTop": 0.5,
              "paddingBottom": 0.5,
              "paddingRight": 0.5,
              "paddingLeft": 0.5,
              "id": "e0a861c5-cebd-4df3-84d4-fb43f0c9feb7",
              "x": 178.0,
              "y": 4.0,
              "width": 31.8,
              "height": 7.9,
              "zIndex": null
            },
            {
              "text": "Sample footer",
              "type": "dynamic-editable",
              "dynamicId": null,
              "inputType": "text",
              "editableId": "page2_footer",
              "format": null,
              "label": "Footer (This text will repeat on every page)",
              "validation": {
                "required": false,
                "maxLength": 1000
              },
              "options": [],
              "multiSelectDelimiter": "comma",
              "radioType": null,
              "value": null,
              "radioLabel": null,
              "inputGroup": "Page 2",
              "isTableText": false,
              "fontSize": 3.0,
              "fontFamily": "Arial",
              "fontColor": null,
              "fontStyle": null,
              "fontWeight": null,
              "lineHeight": null,
              "horizontalAlign": "left",
              "verticalAlign": "middle",
              "isHorizontal": true,
              "borderStyle": null,
              "borderWidth": null,
              "borderColor": null,
              "backgroundColor": "transparent",
              "paddingTop": 0.5,
              "paddingBottom": 0.5,
              "paddingRight": 0.5,
              "paddingLeft": 0.5,
              "id": "df8ae119-d074-4bd5-b538-7a6d0199e90b",
              "x": 8.0,
              "y": 4.0,
              "width": 168.0,
              "height": 8.0,
              "zIndex": null
            }
          ],
          "images": [],
          "lines": [],
          "rectangles": [],
          "height": 15.0
        },
        "pageMarginTop": 0.0,
        "pageMarginBottom": 0.0,
        "pageMarginLeft": 0.0,
        "pageMarginRight": 0.0,
        "paperSize": "Letter",
        "sizeUnit": "mm",
        "fontSizeUnit": "mm",
        "fontSize": 16.0,
        "fontFamily": "Arial"
      }`;
